<header mat-dialog-title class="u-flex-full">
  <span>
    {{'billing-lines.Seleziona riga di fatturazione' | translate}}
  </span>
</header>
<mat-dialog-content>
  <billing-line-list [billingLines]="billingLines" [defaultFilters]="defaultFilters"
    [displayedColumns]="displayedColumns" [total]="total" [canSelect]="true" (onSortChange)="sortChange($event)"
    (onPageChange)="pageChange($event)" (onFilterChange)="filtersChange($event)"
    (onSelectBillingLine)="selectBillingLine($event)"></billing-line-list>
</mat-dialog-content>
<mat-dialog-actions class="u-flex-full">
  <span>
  </span>
  <button mat-raised-button color="basic" type="button" (click)="close()">{{'shared.Chiudi' | translate}}</button>
</mat-dialog-actions>